import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  body: Record<string, any>;
}

export function useLeadsCompartilhados(props: Props & QueryGlobalInterface) {
  const fetchData = async () => {
    const LEADS_COMPARTILHADOS = `${leadsWebEnviroment}/commom/leads/compartilhados/v2`;
    const response = await instance.post(LEADS_COMPARTILHADOS, props.body);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    onError: (error: any) => {
      toast?.error(
        `Erro ao buscar leads Compartilhados. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
